import { render } from "./karussellSwiper2.vue?vue&type=template&id=2ee49411"
import script from "./karussellSwiper2.vue?vue&type=script&lang=js"
export * from "./karussellSwiper2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__